module.exports = __webpack_public_path__ + "static/favicon-16x16-4b738aecc736d23f031026348d716bf1.png";